const DEFAULT_AVATAR_KEY = 'avatar-portraits/hom-default-avatar.png'
const DEFAULT_AVATAR_URL = 'avatars/custom/default/default-avatar-v1.png'

export { DEFAULT_AVATAR_KEY, DEFAULT_AVATAR_URL }
